import type { SyntheticEvent } from "react";
import projectPlaceholder from "@/assets/images/project-placeholder.svg";

export const IMAGE_PLACEHOLDER: string = projectPlaceholder;

/**
 * `onError` handler that swaps a failed image for the bundled placeholder,
 * once: a failing placeholder is left alone rather than retried in a loop.
 */
export function swapToPlaceholder(
	event: SyntheticEvent<HTMLImageElement>,
): void {
	const image = event.currentTarget;
	if (image.getAttribute("src") !== IMAGE_PLACEHOLDER) {
		image.src = IMAGE_PLACEHOLDER;
	}
}
